import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, Type } from '@angular/core';
import { PageType, Section, Site, Page } from '../../../editor-container/editor-model';
import { RenderedSection, SectionEditorBridgeService } from '../../../services/section-editor-bridge.service';
import { Subject, Subscription } from 'rxjs';
import { SectionsEditorService } from '../sections-editor.service';
import { takeUntil } from 'rxjs/operators';
import { PreviewEditStoreService } from '../../../services/preview-edit-store.service';
import { NbDialogService } from '@nebular/theme';
import { SectionEditorDialogComponent } from '../../dialogs/section-editor-dialog/section-editor-dialog.component';
import { EditState } from '../../../model';

@Component({
  selector: 'kve-section-navigator',
  templateUrl: './section-navigator.component.html',
  styleUrls: ['./section-navigator.component.scss']
})
export class SectionNavigatorComponent implements OnInit, OnChanges {
  @Input() section: Section;
  @Input() renderedSections: RenderedSection[];
  sectionId: string;
  shown = true;
  isSelected = false;
  deselect$: Subscription;

  @Output() selectedSectionId: EventEmitter<string> = new EventEmitter<string>();
  @Output() deselectRest: EventEmitter<string> = new EventEmitter<string>();

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private sectionEditorBridgeService: SectionEditorBridgeService,
    private sectionsEditorService: SectionsEditorService,
    private previewEditStoreService: PreviewEditStoreService,
    private dialogService: NbDialogService,
    private renderer2: Renderer2,
    private el: ElementRef<HTMLElement>) { }

  ngOnInit(): void {
    this.deselect$ = this.sectionsEditorService.getSelectedSectionId().pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if (data !== this.sectionId) {
          this.isSelected = false;
        }
      })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["section"]) {
      this.sectionId = this.section.sectionId;
    }
    if (changes["renderedSections"]) {
      // console.log(this.renderedSections)
    }
  }
  /**
   *
   * @param sectionId
   * 1. Select section for editing
   * 2. Check if it's rendered
   * 3. Use section bridge to highlight section in preview window
   * 4. Deselect currently seledted section
   */
  selectSection(sectionId: string) {
    // console.log(`Navigator - Track Selected Section: ${sectionId}`);
    const renderedSection = this.resolveSection(sectionId);
    if (renderedSection != undefined) {
      // console.log(`Navigator - Track Found Rendered: ${sectionId}`);
      // console.log(renderedSection);
      this.sectionEditorBridgeService.setSelectedSection(renderedSection.elementId);
      // this.previewEditStoreService.siteEditorConfigState$.subscribe(data => console.log(data))
      // this.previewEditStoreService.updateSelectedSection()
    } else {
      console.log("can't find section for: " + sectionId)
    }
    this.toggleSelected();
    this.deselectRest.emit(sectionId);
    // console.log(this.section.sectionId+"-"+this.renderedSections.)
  }

  deleteSection(sectionId) {
    const renderedSection = this.resolveSection(sectionId);
    if (renderedSection != undefined) {
      // console.log(renderedSection);
      this.sectionEditorBridgeService.setDelSelectionElement(renderedSection.elementId)
      // this.sectionEditorBridgeService.setSelectedSection(renderedSection.elementId);
    } else {
      console.log("can't find section for: " + sectionId)
    }
  }
  editSection(sectionId: string) {
    console.log(sectionId);
    this.previewEditStoreService.updateSelectedSection(this.section)
    const component: Type<any> = SectionEditorDialogComponent;
    // console.log(this.section);
    /* this.previewEditStoreService.selectedSite$.subscribe((site:Site) => {
      this.previewEditStoreService.selectedPageType$.subscribe((pageType:PageType) => {
        let page:Page = site.pages.find(page => page.pageType == pageType);
        if(page != undefined){
          page.sections.find(section)
        }
      });
    }); */
    this.previewEditStoreService.updateEditState(EditState.EDITING);
    const dialogRef = this.dialogService.open(component, {
      context: {
        title: this.section.sectionData.title,
        section: this.section,
        dialogWidth: 1400
        /* imgSrc:imgSrc,
        cellId:cellId,
        section:this.selectedSection,
        selectedCell:this.selectedCell,
        dialogWidth:960 */
      },
      dialogClass: 'custom-dialog-class',
    })
    dialogRef.onClose.subscribe((resp: Section) => {
      console.log(resp);
      this.previewEditStoreService.updateSelectedSection(resp);
      this.previewEditStoreService.updateEditState(EditState.UPDATED)
    })
  }

  editCells(sectionId: string) {
    console.log(sectionId)
    if (this.isSelected) {
      this.selectedSectionId.emit(sectionId);
      const renderedSection = this.resolveSection(sectionId);
      this.sectionEditorBridgeService.setEditElement(renderedSection.elementId);
    } else {
      console.log("This is not selected");
    }
  }

  upSection(e) {

  }

  downSection(e) {

  }

  toggleShow(sectionId) {
    this.shown = !this.shown;
    // console.log(this.shown);
    const renderedSection = this.resolveSection(sectionId);
    if (renderedSection != undefined) {
      // console.log(renderedSection);
      this.sectionEditorBridgeService.toggleElementVisibility(renderedSection.elementId, this.shown)
      // this.sectionEditorBridgeService.setSelectedSection(renderedSection.elementId);
    } else {
      console.log("can't find section for: " + sectionId)
    }
  }

  toggleSelected() {
    this.isSelected = !this.isSelected;
    if (this.isSelected == true) {
      // console.log("Is selected is true")
      // console.log(this.el.nativeElement)
      // First remove all active elements
      const parentEl = this.el.nativeElement.parentElement.parentElement;
      const activeEls = parentEl.querySelectorAll('.isActive');
      if (activeEls != undefined) {
        // console.log(activeEls)
        activeEls.forEach(el => {
          el.classList.toggle("isActive")
        })
      }
      this.renderer2.addClass(this.el.nativeElement, "isActive");
      this.renderer2.addClass(this.el.nativeElement.parentElement, "isActive");
      this.renderer2.addClass(this.el.nativeElement.firstElementChild, "isActive")
    }
  }

  resolveSection(sectionId: string) {
    let renderedSection: RenderedSection;
    renderedSection = this.renderedSections.find(renderedSection => renderedSection.sectionId == sectionId);
    return renderedSection;
  }
}
